import React from "react";
import { translate } from "../../../services/TranslationService";
import { InfoIcon } from "lucide-react";

const InformationScreen = ({ title = translate("nodata") }) => {
    return (
        <div style={{ flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
            <div>
                <InfoIcon color="gray" size={60} className="mb-3" />
            </div>
            <div style={{ color: "gray" }}>
                {title}
            </div>
        </div>
    )
}

export default InformationScreen;
